import { useCallback } from 'react';
import { LSL_AUTH_DATA, OAUTH_REDIRECT_ROUTE, OAUTH_STATE, QLFF_WL_SESS } from 'config/constants';
import { LSL_AUTH_API_LOGOFF_URL, QH_AUTH_API_LOGOUT_URL } from 'config';
import jscookie from 'js-cookie';
import { ssoLogoutSuccess } from 'store/authentication/sso/actions';
import { useDispatch } from 'react-redux';

interface Option {
  lslOnly: boolean;
}

export interface Result {
  logout: (option?: Option) => Promise<void>;
}

const useOAuthLogout = (): Result => {
  const dispatch = useDispatch();

  const logout = useCallback(
    async (option = { lslOnly: false }) => {
      try {
        const { lslOnly } = option;
        const qhAuthLogout = () => fetch(QH_AUTH_API_LOGOUT_URL, { method: 'POST', credentials: 'include' });
        const lslAuthLogoff = () => fetch(LSL_AUTH_API_LOGOFF_URL, { credentials: 'include' });
        if (lslOnly) {
          await lslAuthLogoff();
        } else {
          await Promise.all([qhAuthLogout(), lslAuthLogoff()]);
        }
      } catch (e) {
        // TODO: Log error
      }

      jscookie.remove(QLFF_WL_SESS);
      jscookie.remove(LSL_AUTH_DATA);
      window.sessionStorage.removeItem(OAUTH_STATE);
      window.sessionStorage.removeItem(OAUTH_REDIRECT_ROUTE);
      dispatch(ssoLogoutSuccess());
    },
    [dispatch],
  );

  return {
    logout,
  };
};

export default useOAuthLogout;
